const siteTypes = [
  // Settlement / habitation
  'settlement general',
  'open-settlement',
  'enclosed-settlement',
  'central-settlement',
  'oppidum',
  'farmstead',
  'deserted-medieval-village',
  // Enclosed / ritual-settlement
  'viereckschanze',
  'rondel',
  'causewayed-enclosure',
  // Fortified / defensive
  'hillfort',
  'fortified-mansion',
  'motte-castle',
  'roman-fort',
  'roman-marching-camp',
  'war-camp',
  // Funerary
  'barrows',
  'necropolis',
  'urnfield',
  // Ritual / other
  'sanctuary',
  'hoard-deposit',
  'production-site',
] as const;

type SiteType = typeof siteTypes[number];

const siteTypeLabels: Record<SiteType, string> = {
  'settlement general': 'Settlement (general)',
  'open-settlement': 'Open settlement',
  'enclosed-settlement': 'Enclosed settlement',
  'central-settlement': 'Central settlement',
  oppidum: 'Oppidum',
  farmstead: 'Farmstead',
  'deserted-medieval-village': 'Deserted medieval village',
  viereckschanze: 'Viereckschanze',
  rondel: 'Rondel',
  'causewayed-enclosure': 'Causewayed enclosure',
  hillfort: 'Hillfort',
  'fortified-mansion': 'Fortified mansion',
  'motte-castle': 'Motte / castle',
  'roman-fort': 'Roman fort / castellum',
  'roman-marching-camp': 'Roman marching camp',
  'war-camp': 'War camp',
  barrows: 'Barrows',
  necropolis: 'Necropolis',
  urnfield: 'Urnfield',
  sanctuary: 'Sanctuary / cult site',
  'hoard-deposit': 'Hoard / deposit findspot',
  'production-site': 'Production site',
};

export { siteTypes, siteTypeLabels };
export type { SiteType };
